import store from '../../store';
import { RENEW } from '@/store/actions/auth.actions';

export const UserLoadedGuard = (to, from, next) => {
  const userLoaded = store.getters.currentUser;
  const userLoading = store.getters.authPending;

  if (!userLoaded && !userLoading) {
    return store.dispatch(RENEW)
      .then(() => next())
      .catch(() => next({name: 'error'}))
  }

  return next();
};